<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-date-input [control]="control" [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                         (focussed$)="onFocussed($event)" *ngSwitchDefault></fui-edit-date-input>
    <fui-filter-date-input [disabled]="disabled" #input [(ngModel)]="value" (focussed$)="onFocussed($event)"
                           [label]="label" *ngSwitchCase="contextType.FILTER"></fui-filter-date-input>
    <fui-inline-date-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"></fui-inline-date-input>
    <fui-pill-date-input [control]="control" [disabled]="disabled" [label]="label" #input [(ngModel)]="value"
                         (focussed$)="onFocussed($event)" (removed$)="remove()"
                         *ngSwitchCase="contextType.PILL"></fui-pill-date-input>
</ng-container>
